import TagManager from "react-gtm-module";

function MajorsRemoveCP({ ipeds }) {
  const tagManagerArgs = {
    dataLayer: {
      event: "interactionEvent",
      eventName: "majors_remove_cp",
      ipeds: ipeds,
    },
  };

  TagManager.dataLayer(tagManagerArgs);
}

export default MajorsRemoveCP;
